import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { Link } from 'react-router-dom';
import { FiClock, FiArrowRight } from 'react-icons/fi';

// Simple countdown helper
const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      if (difference > 0) {
        const d = Math.floor(difference / (1000 * 60 * 60 * 24));
        const h = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const m = Math.floor((difference / 1000 / 60) % 60);
        const s = Math.floor((difference / 1000) % 60);
        setTimeLeft(`${d}d ${h}h ${m}m ${s}s`);
      } else {
        setTimeLeft('ENDED');
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  return <span className="font-mono font-bold tracking-wider">{timeLeft}</span>;
};

const FlashSale = ({ products }) => {
  if (!products || products.length === 0) return null;

  // Find the earliest ending sale
  const validSaleProducts = products.filter(p => p.saleEndTime && new Date(p.saleEndTime) > new Date() && (!p.saleStartTime || new Date(p.saleStartTime) <= new Date()));
  
  if (validSaleProducts.length === 0) return null;

  const targetDate = validSaleProducts[0].saleEndTime;

  return (
    <section className="py-12 bg-gradient-to-r from-purple-900 via-indigo-900 to-navy overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Ribbon */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 pb-4 border-b border-white/10 gap-4">
           <div>
              <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white flex items-center gap-3">
                 <span className="text-yellow-400">⚡</span> Flash Sale
              </h2>
              <p className="text-purple-200 text-sm mt-1">Grab these exclusive deals before time runs out!</p>
           </div>
           <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3 flex items-center gap-3 text-white">
              <FiClock className="animate-pulse text-yellow-400" />
              <div className="text-sm">Ends In: <span className="text-yellow-400"><CountdownTimer targetDate={targetDate} /></span></div>
           </div>
        </div>

        {/* Scrollable Products */}
        <div className="overflow-x-auto pb-4 -mx-4 px-4 flex gap-6 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
          {validSaleProducts.map((product) => (
            <div key={product._id} className="min-w-[280px] md:min-w-[300px] bg-white rounded-2xl p-2 shadow-2xl" style={{ scrollSnapAlign: 'start' }}>
               <ProductCard product={product} />
            </div>
          ))}
          
          {/* Shop All Link Card */}
          <div className="min-w-[280px] md:min-w-[300px] bg-white/5 border border-white/10 rounded-2xl flex flex-col items-center justify-center p-6 card-hover" style={{ scrollSnapAlign: 'start' }}>
             <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center text-white mb-4">
                <FiArrowRight size={24} />
             </div>
             <h3 className="text-white font-playfair text-xl mb-2">View All Deals</h3>
             <Link to="/products?sale=true" className="btn-gold px-6 py-2 text-sm">Shop Sale</Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FlashSale;
